var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',[_c('v-tab',{attrs:{"to":"/register/documents"}},[_vm._v("\n      Documents\n    ")]),_c('v-tab',{attrs:{"to":"/register/assets"}},[_vm._v("\n      Assets\n    ")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }